import LoginView from "./login.html";
import EditPasswordModalView from "../users/editPasswordModal.html";
import ForgottenPswModalView from "./forgottenPswModal.html";


angular.module("login", [])

/*    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
             .state('login', {
                 url: "/login",
                 views: {
                     'loginContent': {
                         template: LoginView,
                         controller: 'LoginCtrl'
                     }
                 }
             })
        ;
    }])*/

    .controller('LoginCtrl', ['$translate', '$scope', 'LoginService', '$rootScope', '$uibModal', '$http', '$state', 'modalService', 'Restangular', '$stateParams', '$timeout', 'logService', '$window', '$document', function ($translate, $scope, LoginService, $rootScope, $uibModal, $http, $state, modalService, Restangular, $stateParams, $timeout, logService, $window, $document) {
        $scope.onKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) $scope.doLogin();
        }

        $rootScope.loginProcess = false;

        /*Restangular.all('AuthenticationProcesses/Enabled').getList().then(function (data) {
            logService.debug(data);
            if(data.length > 0) {
                $state.go("auth-process-init");
            } else {*/
                $scope.disableLocalLogin = false;
                Restangular.one('Auth/localusers/status').get().then(function (data) {
                    $scope.disableLocalLogin = data === true;
                });
        
                $scope.enableWebauthn = false;
                Restangular.one('Auth/WebAuthn/status').get().then(function (data) {
                    $scope.enableWebauthn = data === true;
                });
        /*
                Restangular.all('Auth/Services').getList().then(function (services) {
                    // Add to scope only services with openid configuration URL
                    $scope.services = services.filter(s => s.openid_configuration != null);
                });

            }
        });*/

        $scope.loginData = {};
        $scope.alerts = {};
        
        if($rootScope.inactivityLogout != null) {
            $scope.alerts = [
                { type: 'danger', msg: 'Sesión caducada por inactividad.' }
            ];
            $rootScope.inactivityLogout = null;
        }

        $rootScope.islogged = false;
        $scope.services = null;

        if (LoginService.isLoggedIn()) {
            $rootScope.islogged = true;
        } else {
            if (LoginService.wantToBeRemembered() == "true") {
                $scope.loginData.username = LoginService.get("user");
                $scope.loginData.remember = true;
            }
        }

        Restangular.all('Auth/Services').getList().then(function (services) {
            // Add to scope only services with openid configuration URL
            $scope.services = services.filter(s => s.openid_configuration != null);
        });

        let coerceToBase64Url = function (thing) {
            // Array or ArrayBuffer to Uint8Array
            if (Array.isArray(thing)) {
                thing = Uint8Array.from(thing);
            }

            if (thing instanceof ArrayBuffer) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to base64
            if (thing instanceof Uint8Array) {
                var str = "";
                var len = thing.byteLength;

                for (var i = 0; i < len; i++) {
                    str += String.fromCharCode(thing[i]);
                }
                thing = window.btoa(str);
            }

            if (typeof thing !== "string") {
                throw new Error("could not coerce to string");
            }

            // base64 to base64url
            // NOTE: "=" at the end of challenge is optional, strip it off here
            thing = thing.replace(/\+/g, "-")
                .replace(/\//g, "_")
                .replace(/={1,5}$/g, "");

            return thing;
        };

        let coerceToArrayBuffer = function (thing, name) {
            if (typeof thing === "string") {
                // base64url to base64
                thing = thing.replace(/-/g, "+").replace(/_/g, "/");

                // base64 to Uint8Array
                var str = window.atob(thing);
                var bytes = new Uint8Array(str.length);
                for (var i = 0; i < str.length; i++) {
                    bytes[i] = str.charCodeAt(i);
                }
                thing = bytes;
            }

            // Array to Uint8Array
            if (Array.isArray(thing)) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to ArrayBuffer
            if (thing instanceof Uint8Array) {
                thing = thing.buffer;
            }

            // error if none of the above worked
            if (!(thing instanceof ArrayBuffer)) {
                throw new TypeError("could not coerce '" + name + "' to ArrayBuffer");
            }

            return thing;
        };

        let verifyAssertionWithServer = async function (assertedCredential) {
            logService.debug("Verifying assertion with server");
            logService.debug(assertedCredential);
            // Move data into Arrays incase it is super long
            let authData = new Uint8Array(assertedCredential.response.authenticatorData);
            let clientDataJSON = new Uint8Array(assertedCredential.response.clientDataJSON);
            let rawId = new Uint8Array(assertedCredential.rawId);
            let sig = new Uint8Array(assertedCredential.response.signature);
            let userHandle = new Uint8Array(assertedCredential.response.userHandle)
            const data = {
                id: assertedCredential.id,
                rawId: coerceToBase64Url(rawId),
                type: assertedCredential.type,
                extensions: assertedCredential.getClientExtensionResults(),
                response: {
                    authenticatorData: coerceToBase64Url(authData),
                    clientDataJSON: coerceToBase64Url(clientDataJSON),
                    userHandle: userHandle !== null ? coerceToBase64Url(userHandle): null,
                    signature: coerceToBase64Url(sig)
                }
            };

            Restangular.all('Auth').customPOST(JSON.stringify(data), 'WebAuthn/MakeAssertion', {}, {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }).then(function (response) {
                // show error
                if (response.AssertionVerificationResult.status !== "ok") {
                    logService.error("Error doing assertion");
                    logService.error(response.AssertionVerificationResult.errorMessage);
                    return;
                }

                processAuthenticationInfo(response.AuthenticationInfo);
                logService.debug("Assertion verified!");
            });
        };
        
        const processAuthenticationInfo = function (data) {
            $rootScope.offersPermission = "";
            if (data.token.success) {
                localStorage.removeItem("authService");

                $http.defaults.headers.common["Authorization"] = "Bearer " + data.token.accessToken;
                LoginService.saveTokenInfo(data);
                $rootScope.islogged = true;

                $rootScope.roles_permissions = data.roles_permissions;

                //configuramos lenguaje de usuario
                $translate.use(data.language);
                $http.defaults.headers.common["language_code"] = data.language;

                let validTo = Date.parse(data.token.validTo);

                let timeValid =Math.abs(validTo - Date.now());

/*                $timeout(function () {
                    logService.debug("Salta el timeout");
                    $scope.refreshToken();
                }, timeValid - 180000);*/

                //Si ha entrado con contraseña temporal, se lanza el popup para cambiarla.
                if (data.temporal_password) {

                    Restangular.one('Users', data.token.userId).get().then(function (results) {
                        $scope.user = results;
                        let $modalInstance = $uibModal.open({
                            animation: true,
                            template: EditPasswordModalView,
                            controller: "EditPasswordModalCtrl",
                            resolve: {
                                user: function () {
                                    return $scope.user;
                                }
                            }
                        });
                    });
                }

                $state.go('dashboard.list');
            } else {
                $scope.alerts = [
                    { type: 'danger', msg: data.token.errorMessage }
                ];
            }
        };
        
        $scope.doWebauthnLogin = function () {
            Restangular.all('Auth').customPOST({}, 'WebAuthn/AssertionOptions', {}).then(async function (makeAssertionOptions) {
                logService.debug(makeAssertionOptions);
                if (makeAssertionOptions.status === "ok") {
                    const challenge = makeAssertionOptions.challenge.replace(/-/g, "+").replace(/_/g, "/");
                    makeAssertionOptions.challenge = Uint8Array.from(atob(challenge), c => c.charCodeAt(0));

                    // fix escaping. Change this to coerce
                    makeAssertionOptions.allowCredentials.forEach(function (listItem) {
                        var fixedId = listItem.id.replace(/\_/g, "/").replace(/\-/g, "+");
                        listItem.id = Uint8Array.from(atob(fixedId), c => c.charCodeAt(0));
                    });

                    // ask browser for credentials (browser will ask connected authenticators)
                    let credential;
                    try {
                        credential = await navigator.credentials.get({ publicKey: makeAssertionOptions })
                    } catch (err) {
                        logService.error(err);
                    }

                    try {
                        await verifyAssertionWithServer(credential);
                    } catch (e) {
                        logService.error(e);
                    }
                }
            });
        };
        
        // Perform the login action when the user submits the login form
        $scope.doLogin = function () {
            if ($scope.loginData.username == "" || $scope.loginData.password == "" || $scope.loginData.username == null || $scope.loginData.password == null) {
                $scope.alerts = [
                            { type: 'danger', msg: 'Debes indicar tu nombre de usuario y contraseña de acceso.' }
                ];
                return;
            }

            LoginService.loginUser($scope.loginData.username, $scope.loginData.password)
                .then(function (data) {
                    $rootScope.offersPermission = "";
                    if (data.token.success) {          
                        localStorage.removeItem("authService");
                        
                        LoginService.saveTokenInfo(data, $scope.loginData);
                        $rootScope.islogged = true;

                        $rootScope.roles_permissions = data.roles_permissions;

                        //configuramos lenguaje de usuario
                        $translate.use(data.language);
                        $http.defaults.headers.common["language_code"] = data.language;
                        
/*                        let validTo = Date.parse(data.token.validTo);
                      
                        let timeValid =Math.abs(validTo - Date.now());
                        
                        $timeout(function () {
                            logService.debug("Salta el timeout");
                            $scope.refreshToken();
                        }, timeValid - 180000);*/
                        
                        //Si ha entrado con contraseña temporal, se lanza el popup para cambiarla.
                        if (data.temporal_password) {
                            
                            Restangular.one('Users', data.token.userId).get().then(function (results) {
                                $scope.user = results; 
                                let $modalInstance = $uibModal.open({
                                    animation: true,
                                    template: EditPasswordModalView,
                                    controller: "EditPasswordModalCtrl",
                                    resolve: {
                                        user: function () {
                                            return $scope.user;
                                        }
                                    }
                                });
                            });
                        }

                        $state.go('dashboard.list');
                    } else {
                        $scope.alerts = [
                            { type: 'danger', msg: data.token.errorMessage }
                        ];
                    }
                }, 
                function (data) {
                    $scope.alerts = [
                        { type: 'danger', msg: 'Ha ocurrido un error, inténtelo de nuevo más tarde.' }
                    ];
            });

        };

        $scope.closeSession = function () {
            LoginService.closeSession();
        }

        $scope.forgottenPswModal = {};
        $scope.selectedService = { value: null };

        function dec2hex (dec) {
            return dec.toString(16).padStart(2, "0")
        }
        
        function generateId (len) {
            var arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, dec2hex).join('')
        }
        
        $scope.loginExternal = function(service) {
            let openid = JSON.parse(service.openid_configuration);
            
            // cuando pasemos el proceso completo de proxy de login al servidor quitar el false
            if(service.proxy_token_request === true && false) {
                $http.get("/api/auth/Challenge/" + service.id).then(function (response) {
                    $window.location.href = response.data;
                });
            } else {
                let nonce = generateId(16);
                let state = generateId(16);
                let codeVerifier = generateId(64);

                service.nonce = nonce;
                service.state = state;
                service.codeVerifier = codeVerifier;

                localStorage.setItem("authService", JSON.stringify(service));

                let codeChallenge = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);

                let url = openid.authorization_endpoint
                    + "?response_type=code&client_id=" + encodeURIComponent(service.client_id)
                    + "&scope=" + encodeURIComponent(service.scopes)
                    + "&response_mode=query"
                    + "&state=" + encodeURIComponent(state)
                    + "&nonce=" + encodeURIComponent(nonce)
                    + "&redirect_uri=" + encodeURIComponent(service.callback_url)
                    + "&code_challenge=" + codeChallenge.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
                    + "&code_challenge_method=S256";

                if (openid.client_secret != null) {
                    url += "&client_secret=" + encodeURIComponent(openid.client_secret);
                }

                logService.debug("Cargo la url " + url + " en una nueva ventana");

                let win = window.open(url, "_blank", "");


                const interval = setInterval(() => {
                    if (win.closed) {
                        clearInterval(interval);
                        // window.location.reload();
                        /*                    let expires = parseInt(LoginService.get("expires_in"));
                        
                                            $timeout(function () {
                                                $scope.refreshToken();
                                            }, (expires - 60) * 1000);*/

                        $timeout(function () {
                            if (LoginService.isLoggedIn()) {
                                Restangular.one('Auth/UserInfo').get().then(function (data2) {
                                    logService.debug("UserInfo fetched");
                                    logService.debug("UserInfo fetched");
                                    LoginService.set("userId", data2.user_id);
                                    LoginService.set("userIcon", data2.user_icon);
                                    LoginService.set("companyId", data2.company_id);
                                    LoginService.set("rolesPermissions", data2.roles_permissions);
                                    $rootScope.islogged = true;
                                    $rootScope.roles_permissions = data2.roles_permissions;
                                    $translate.use(data2.language);
                                    $http.defaults.headers.common["language_code"] = data2.language;

                                    logService.debug("Login externo correcto. Cargamos el dashboard");
                                    $state.go('dashboard.list');
                                });
                            }
                        }, 1000);
                    }
                }, 500);
            }
        }
        
        $scope.ForgottenPswDialog = function () {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: ForgottenPswModalView,
                controller: "ForgottenPswModalCtrl"
                
            });

            $modalInstance.result.then(function (resultModal) {
                if (angular.isDefined(resultModal.email) && resultModal.email != "") {

                    $http.post((window as any).CONFIG.api_url + 'Auth/CreateNewPass', { email: resultModal.email })
                       .then(function (data, status, headers, config) {
                           modalService.message({
                               title: "Correo enviado",
                               message: "Si existe un usuario con esa cuenta, se le ha enviado al correo proporcionado una contraseña temporal. ",
                               onAccept: function () {
                                   $modalInstance.dismiss('cancel');
                               }
                           });
                       })
                       .catch(function (data, status, headers, config) {
                           logService.debug("error");
                       });
                }

            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        }; //ForgottenPswDialog

    }])
    

 .controller("ForgottenPswModalCtrl", ['$scope', '$uibModalInstance', 'modalService', function ($scope, $uibModalInstance, modalService) {

     $scope.forgottenPswModal = {};

     $scope.onCancel = function () {
         $uibModalInstance.dismiss('cancel');
     };

     $scope.sendEmail = function () {
         //Devolvemos el control al principal
         $uibModalInstance.close($scope.forgottenPswModal);

     };//saveTranslation


 }])
;